<template>
  <div class="col-9 pl-0 ml-0">
    <v-row>
      <v-col>
        <p class="title pl-0 ml-0 mt-5">PC 쇼핑몰 - 정품 인증 화면 만들기</p>
        <p class="mb-0 subtitle-2 font-weight-light pl-0">
          [카페24 어드민 > 디자인관리] 메뉴에서 '
          <font class="blue--text font-weight-bold pl-0"
            >쇼핑몰 디자인 수정</font
          >' 버튼을 클릭합니다.
        </p>
        <p class="mb-0 subtitle-2 font-weight-light pl-0">
          클릭하시면 스마트디자인 편집창이 노출되게 됩니다.
        </p>
        <p class="mb-0 subtitle-2 font-weight-light pl-0 pb-2">
          좌측 하단에 위치한 '
          <font class="font-weight-bold pl-0">+ 화면추가</font>' 버튼을
          클릭해주세요.
        </p>
      </v-col>
    </v-row>
    <hr class="grey lighten-4" />

    <v-row class="pt-5 pl-0">
      <v-col class="pl-0">
        <v-img :src="guidImgPc1" frameborder="0"></v-img>
      </v-col>
    </v-row>

    <v-row class="pl-0 pt-5">
      <v-col>
        <p class="mb-0 subtitle-2 font-weight-light pl-0">
          클릭하시면 아래의 '쇼핑몰 화면 추가' 창이 노출하게 됩니다.
        </p>
        <p class="mb-0 subtitle-2 font-weight-light pl-0">
          파일명을 입력하는 칸에 아래 영문을 복사하여 넣어주세요.
        </p>
      </v-col>
      <v-col class="mb-0 subtitle-2 font-weight-light pl-0">
        <v-row align="end" justify="end" class="mt-5 mr-0">
          <font class="font-weight-bold">royalty.html</font>
          <v-btn
            small
            color="grey darken-4 ml-2"
            class="white--text ml-0 mr-0 pl-4 pr-4 pr-0"
            @click="textCopy('f')"
            >복사하기</v-btn
          >
        </v-row>
      </v-col>
    </v-row>

    <hr class="grey lighten-4" />

    <v-row class="pt-5 pl-0">
      <v-col class="pl-0">
        <v-img :src="guidImgPc2" frameborder="0"></v-img>
      </v-col>
    </v-row>

    <v-row class="pl-0 pt-5">
      <v-col>
        <p class="mb-0 subtitle-2 font-weight-light pl-0">
          아래와 같이 새로운 화면이 추가되게 됩니다.
        </p>
        <p class="mb-0 subtitle-2 font-weight-light pl-0">
          2번째 행에 정품 인증 소스를 복사하여 붙여주시고, 상단의 '저장'버튼을
          클릭하면 완료됩니다.
        </p>
      </v-col>
      <v-col class="mb-0 subtitle-2 font-weight-light pl-0">
        <v-row align="end" justify="end" class="mt-6 mr-0">
          <v-btn
            small
            color="grey darken-4 ml-2"
            class="white--text ml-0 mr-0 pl-4 pr-4 pr-0"
            @click="textCopy('s')"
            >정품 인증 소스 복사하기</v-btn
          >
        </v-row>
      </v-col>
    </v-row>

    <hr class="grey lighten-4" />

    <v-row class="pt-5 pl-0">
      <v-col class="pl-0">
        <v-img :src="guidImgPc3" frameborder="0"></v-img>
      </v-col>
    </v-row>

    <v-row class="pl-0 pt-5">
      <v-col>
        <p class="mb-0 subtitle-2 font-weight-light pl-0 text-center">
          모두 따라하셨나요?
        </p>
        <p class="mb-0 subtitle-2 font-weight-light pl-0 text-center">
          내 PC 쇼핑몰에 '정품 인증 화면'이 완료되었습니다.
        </p>
        <p class="mb-0 subtitle-2 font-weight-light pl-0 text-center">
          모바일 쇼핑몰도 동일하게 적용해주세요.
        </p>

        <p class="mb-0 subtitle-2 font-weight-light pl-0 text-center mt-5">
          위 과정을 모두 완료하셨다면
        </p>
        <p class="mb-0 subtitle-2 font-weight-light pl-0 text-center">
          아래의 쇼핑몰 정품 인증 페이지 경로를 확인하시고
        </p>
        <p class="mb-0 subtitle-2 font-weight-light pl-0 text-center">
          배너등 연결하여 사용하시길 바랍니다.
        </p>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card class="mx-auto" max-width="344" outlined>
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="headline mb-1 text-center"
                >정품 인증 페이지 경로</v-list-item-title
              >
              <v-list-item-subtitle class="text-center">{{
                urlCopy
              }}</v-list-item-subtitle>
              <v-col class="mb-0 subtitle-2 font-weight-light pl-0">
                <v-row align="center" justify="center" class="mt-2">
                  <v-btn
                    small
                    color="grey darken-4 "
                    class="white--text"
                    @click="textCopy('u')"
                    >복사하기</v-btn
                  >
                </v-row>
              </v-col>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CommonMixin from "@/mixins/CommonMixin.js";
import store from "../../../store";

export default {
  data() {
    return {
      description: "",
      fileCopy: "royalty.html",
      sourceCopy: "",
      urlCopy: "https://" + store.state.mallId + ".cafe24.com/royalty.html",
      guidImgPc1: require("../../../assets/authservice/images/guide1_pc.jpg"),
      guidImgPc2: require("../../../assets/authservice/images/guide2_pc.jpg"),
      guidImgPc3: require("../../../assets/authservice/images/guide3_pc.jpg")
    };
  },
  components: {},
  mixins: [CommonMixin],
  methods: {
    textCopy: function(copyType) {
      let text;

      if (copyType == "s") {
        text = this.sourceFileReader();
        this.alertShow("복사 되었습니다.");
        return;
      }

      if (copyType == "f") {
        text = this.fileCopy;
      }

      if (copyType == "u") {
        text = this.urlCopy;
      }

      var aux = document.createElement("input");
      aux.setAttribute("value", text);
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      document.body.removeChild(aux);

      this.alertShow("복사 되었습니다.");
    },
    sourceFileReader() {
      var rawFile = new XMLHttpRequest();
      rawFile.open(
        "GET",
        "/authservice/etc/userfront/src/sourceInfo.html",
        false
      );
      rawFile.onreadystatechange = function() {
        if (rawFile.readyState === 4) {
          if (rawFile.status === 200 || rawFile.status == 0) {
            var allText = rawFile.responseText;

            var aux = document.createElement("input");
            aux.setAttribute("value", allText);
            document.body.appendChild(aux);
            aux.select();
            document.execCommand("copy");
            document.body.removeChild(aux);
          }
        }
      };
      rawFile.send(null);
    }
  }
};
</script>
